import AppContainer from "spot-component-library/lib/components/layout/app-container/AppContainer";
import { Route, Router } from "./components/router/Router";
import { ErrorSubscription } from "./modules/ErrorSubscription/ErrorSubscription";
import { ActiveRateAgreement } from "./modules/activeRateAgreement/ActiveRateAgreement";
import { RateAgreementMain } from "./modules/rateAgreementMain/RateAgreementMain";
import { RateAgreementTeaser } from "./modules/rateAgreementTeaser/RateAgreementTeaser";
import { ReminderSubscription } from "./modules/subscribeReminderRateAgreement/ReminderSubscription";
import { SuccessSubscription } from "./modules/successSubscription/SuccessSubscription";
import { SettlementFeeProvider } from "./contexts/SettlementFeeContext";

interface FeatureToggle {
    rateAgreementReminderEnabled?: boolean;
}

export default function RateAgreementApp(props: FeatureToggle) {
    return (
        <AppContainer header={{ menuLoginEnabled: true }}>
            <div>
                <Router>
                    <Route path="">
                        <SettlementFeeProvider>
                            <RateAgreementMain />
                        </SettlementFeeProvider>
                    </Route>
                    <Route path="successSubscription">
                        <div className="teaser-wrapper">
                            <SuccessSubscription />
                        </div>
                    </Route>
                    <Route path="errorSubscription">
                        <div className="teaser-wrapper">
                            <ErrorSubscription />
                        </div>
                    </Route>
                    <Route path="rateAgreementTeaser">
                        <div className="teaser-wrapper">
                            <RateAgreementTeaser />
                        </div>
                    </Route>
                    <Route path="rateAgreementReminder">
                        {/** Feature toggle for rate agreement reminder */}
                        {!props?.rateAgreementReminderEnabled && <p style={{ fontSize: "50px", textAlign: "center" }}>You are not supposed to be here!!!</p>}
                        {props?.rateAgreementReminderEnabled && <ReminderSubscription />}
                    </Route>
                    <Route path="activeRateAgreement">
                        <ActiveRateAgreement />
                    </Route>
                </Router>
            </div>
        </AppContainer>
    );
}
